import React from "react";

/**
 * Utility functions for detecting and handling Google Translate
 */

/**
 * Detects if Google Translate is currently active on the page
 */
const isGoogleTranslateActive = (): boolean => {
  // Check for Google Translate classes on html element
  if (
    document.documentElement.classList.contains("translated-ltr") ||
    document.documentElement.classList.contains("translated-rtl")
  ) {
    return true;
  }

  // Check for Google Translate banner
  if (document.querySelector(".goog-te-banner-frame")) {
    return true;
  }

  // Check for Google Translate modified elements
  if (document.querySelector('font[style*="vertical-align: inherit"]')) {
    return true;
  }

  return false;
};

/**
 * Hook to detect Google Translate and re-render when it changes
 */
export const useGoogleTranslateDetection = () => {
  const [isTranslateActive, setIsTranslateActive] = React.useState(
    isGoogleTranslateActive()
  );

  React.useEffect(() => {
    // Check periodically for Google Translate activation
    const interval = setInterval(() => {
      const active = isGoogleTranslateActive();
      if (active !== isTranslateActive) {
        setIsTranslateActive(active);
      }
    }, 1000);

    // Also listen for DOM mutations that might indicate Google Translate
    const observer = new MutationObserver(() => {
      const active = isGoogleTranslateActive();
      if (active !== isTranslateActive) {
        setIsTranslateActive(active);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, [isTranslateActive]);

  return isTranslateActive;
};
